import { requestWithRetry } from '../axios'
import { tokenStore } from '../tokenStore'

export const getUser = async () => {
  try {
    const response = await requestWithRetry('upauth/details', 'get')
    return response
  } catch (error: any) {
    localStorage.removeItem('user')
    tokenStore.clear()
    return error.response?.data
  }
}
